export class OverDuePendingReq{
    startMonth:number
    startYear:number
    constructor(
        startMonth:number,
        startYear:number
    ){
     this.startMonth=startMonth
     this.startYear=startYear
    }
}

export class scheduleOrderReport{
    product:string
    date?:any
    constructor( product:string,date?:any){
     this.product=product
     this.date=date
    }
}